import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AppResource } from 'src/app/app.resource';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ResumeStep } from 'src/app/shared/models/model/concretes/components/resume-step.model';

@Component({
  selector: 'app-resume-step',
  templateUrl: './resume-step.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class ResumeStepComponent extends BaseComponent implements OnInit {
  resumeStep!: ResumeStep;

  get brand() {
    return environment.brand;
  }

  constructor(resources: AppResource) {
    super(resources);
  }

  override ngOnInit() {}

  getAlign(): string | null {
    var scrollingElement = document.getElementById('scrollResumeStep');
    if (scrollingElement != null) {
      scrollingElement.scrollTo(0, scrollingElement.scrollHeight);
    }

    if (this.resumeStep.steps?.length === 1) return 'oneValue';
    else if (this.resumeStep.steps?.length === 2) return 'twoValue';
    else return null;
  }
}
